import { LitLab } from 'common-types'
import { Col, Container, Row } from 'components/grid'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import PrintWrapper from '../themes/ThemeChart/PrintWrapper'
import ENILPracticeCards from './ENILPracticeCards'
import FSTK from './FSTK'
import FSTKSpanish from './FSTKSpanish'
import HookBooksHs from './HookBooksHs'
import HundredBookChallenge from './HundredBookChallenge'
import IRLAPracticeCards from './IRLAPracticeCards'
import LitlabModuleCard from './LitlabModuleCard'
import MaterialItem from './MaterialItem'
import SchoolPace from './SchoolPace'
import SuperReaderCape from './SuperReaderCape'
import TakeHomeBookBags from './TakeHomeBookBags'
import TeacherResourceKit from './TeacherResourceKit'
import TeacherResourceKitSpanish from './TeacherResourceKitSpanish'
import WordStudyClassroomResources from 'components/arc-core/WordStudyClassroomResources'
import { P } from 'components/typography/Paragraph'
import { HundredBookChallengeModule } from 'components/100-book-challenge/Modules'

interface Props {
	hundredBookChallenge: HundredBookChallengeModule['leveledLibrary']
	grade: 'k-2' | '3-5' | '6-8' | 'hs'
	language: 'english' | 'spanish'
	cape?: boolean
	fstk?: IGatsbyImageData
	standard?: 'CCSS' | 'TEKS'
	data: LitLab
	hookBooks?: LitLab['hookBookLibrary']
	isCompatible?: boolean
}

const WholeYear = ({ hundredBookChallenge, grade, language = 'english', cape, fstk, standard = 'CCSS', data, hookBooks, isCompatible }: Props) => {
	return (
		<Container gray>
			<Row center className="pt-10">
				<Col width="md:w-8/12">
					<div className="mb-10 text-center">
						<span className="mb-2 font-inter text-3xl font-extrabold leading-tight md:text-4xl md:leading-normal">Tools for the Whole School Year</span>
						<P className="mb-1">Unit 1 launches the yearlong reading systems that provide differentiated, accelerated supports for all students.</P>
					</div>
				</Col>
			</Row>
			<Row>
				{grade === 'hs' ? (
					hookBooks && (
						<Col className="material-column">
							<HookBooksHs baskets={hookBooks} />
						</Col>
					)
				) : (
					<Col className="material-column">
						<HundredBookChallenge baskets={hundredBookChallenge} />
					</Col>
				)}
			</Row>
			<Row center>
				<Col width="sm:w-1/3" className="material-column">
					{language === 'english' ? <TeacherResourceKit standard={standard} /> : <TeacherResourceKitSpanish standard={standard} />}
				</Col>
				<Col width="sm:w-1/3" className="material-column">
					{language === 'english' ? <IRLAPracticeCards grade={grade} /> : <ENILPracticeCards grade={grade} />}
				</Col>
				<Col width="sm:w-1/3" className="material-column">
					<TakeHomeBookBags grade={grade} />
				</Col>
			</Row>

			{cape ? (
				<Row center>
					{!isCompatible && fstk && (
						<Col width="sm:w-1/3" className="material-column">
							{language === 'english' ? <FSTK image={fstk} /> : <FSTKSpanish image={fstk} />}
						</Col>
					)}
					<Col width="sm:w-1/3" className="material-column">
						<SchoolPace cape />
					</Col>
					<Col width="sm:w-1/3" className="material-column">
						<MaterialItem name="Professional Learning" />
					</Col>
					<Col width="sm:w-1/3" className="material-column">
						<SuperReaderCape />
					</Col>
					{!isCompatible && (
						<Col width="sm:w-1/3" className="material-column">
							<WordStudyClassroomResources language={language} />
						</Col>
					)}
				</Row>
			) : (
				<Row center>
					{!isCompatible && fstk && (
						<Col width="sm:w-1/3" className="material-column">
							{language === 'english' ? <FSTK image={fstk} /> : <FSTKSpanish image={fstk} />}
						</Col>
					)}
					<Col width="sm:w-1/3" className="material-column">
						<MaterialItem name="SchoolPace" />
					</Col>
					<Col width="sm:w-1/3" className="material-column">
						<MaterialItem name="Professional Learning" />
					</Col>
				</Row>
			)}
			<div className="flex justify-end pr-6 pb-6 text-ab-100">
				<PrintWrapper buttonText="Module Checklist">
					<div className="hidden print:block">
						<LitlabModuleCard data={data} />
					</div>
				</PrintWrapper>
			</div>
		</Container>
	)
}

export default WholeYear
